import React, { useState } from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle, LuxuryButton, EmptyState } from "@/components/lux";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Megaphone, Trash2, Eye, EyeOff } from "lucide-react";

const inp = "w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white outline-none focus:border-[var(--gold)]/50";

export default function AdminNews() {
  const { data, loading, reload } = useFetch("/admin/news");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const items = data?.news || [];

  const add = async (e) => {
    e.preventDefault();
    if (!msg.trim()) return;
    setBusy(true);
    try { await api.post("/admin/news", { message: msg, active: true }); toast.success("Published"); setMsg(""); reload(); }
    catch (err) { toast.error(apiError(err.response?.data?.detail) || "Failed"); }
    finally { setBusy(false); }
  };
  const toggle = async (id) => { await api.post(`/admin/news/${id}/toggle`); reload(); };
  const del = async (id) => { await api.delete(`/admin/news/${id}`); toast.success("Deleted"); reload(); };

  return (
    <div className="space-y-6" data-testid="admin-news">
      <PageTitle title="News & Announcements" subtitle="Publish a message — it scrolls as a live ticker in every member's panel header." />
      <GlassCard className="p-6">
        <form onSubmit={add} className="flex flex-col gap-3 sm:flex-row">
          <input className={inp} placeholder="Type an announcement for all members..." value={msg} onChange={(e) => setMsg(e.target.value)} data-testid="news-input" />
          <LuxuryButton type="submit" variant="gold" disabled={busy} data-testid="news-publish"><Megaphone size={15} className="mr-1 inline" /> Publish</LuxuryButton>
        </form>
      </GlassCard>
      <GlassCard className="p-6">
        {loading ? <div className="skeleton h-32" /> : items.length ? (
          <div className="space-y-2">
            {items.map((n) => (
              <div key={n.news_id} className="flex items-center justify-between gap-3 rounded-xl glass-2 p-3" data-testid={`news-row-${n.news_id}`}>
                <div className="min-w-0">
                  <p className="truncate text-sm text-white">{n.message}</p>
                  <p className="text-[11px] text-[var(--text-dim)]">{n.news_id} · {(n.created_at || "").slice(0, 16).replace("T", " ")} · {n.active ? "Active" : "Hidden"}</p>
                </div>
                <div className="flex shrink-0 gap-2">
                  <button onClick={() => toggle(n.news_id)} className="btn3d btn3d-dark rounded-lg px-3 py-1.5 text-xs" data-testid={`news-toggle-${n.news_id}`}>{n.active ? <EyeOff size={14} /> : <Eye size={14} />}</button>
                  <button onClick={() => del(n.news_id)} className="btn3d btn3d-maroon rounded-lg px-3 py-1.5 text-xs text-white" data-testid={`news-delete-${n.news_id}`}><Trash2 size={14} /></button>
                </div>
              </div>
            ))}
          </div>
        ) : <EmptyState icon={Megaphone} title="No announcements yet" />}
      </GlassCard>
    </div>
  );
}
